export var createBlobEventFactory = function (nativeBlobEventConstructor) {
    return function (type, blobEventInit) {
        if (nativeBlobEventConstructor === null) {
            throw new Error('A native BlobEvent could not be created.');
        }
        return new nativeBlobEventConstructor(type, blobEventInit);
    };
};
//# sourceMappingURL=blob-event-factory.js.map
